export const Second = 1000

export const Minute = 60 * Second

export const Hour = 60 * Minute

export function fullDaysBetween(date1: Date, date2: Date): number {
    // Normalize both dates to midnight (00:00:00) to consider only full days
    const start = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const end = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    // Calculate the difference in milliseconds
    const differenceInMs = end.getTime() - start.getTime();

    // Convert the difference from milliseconds to full days
    const fullDays = differenceInMs / (1000 * 60 * 60 * 24);

    // Return the absolute value to ensure positive result
    return Math.abs(fullDays);
}